export const postHireStatuses = {
  orientationCompleted: 'orientation_completed',
  postSecondaryEducationUnderway: 'post_secondary_education_underway',
  postSecondaryEducationCompleted: 'post_secondary_education_completed',
  cohortUnsuccessful: 'cohort_unsuccessful',
};

export const postHireStatusesValues = Object.values(postHireStatuses).sort();
